import { render, staticRenderFns } from "./document-history.vue?vue&type=template&id=63eb225c&scoped=true&"
import script from "./document-history.vue?vue&type=script&lang=ts&"
export * from "./document-history.vue?vue&type=script&lang=ts&"
import style0 from "./document-history.vue?vue&type=style&index=0&id=63eb225c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb225c",
  null
  
)

export default component.exports